import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Subscription } from '../_models/subscription';
import { MessageResponse } from '../_models/responses';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class SubscriptionService {
    constructor(private http: HttpClient) {}

    getPropertySubscription(propertyId: number): Observable<Subscription | Subscription[]> {
        return this.http.get<Subscription | Subscription[]>(`${environment.apiUrl}/api/subscription/property/${propertyId}`);
    }

    createSubscription(subscription: Partial<Subscription>): Observable<MessageResponse> {
        return this.http.post<MessageResponse>(`${environment.apiUrl}/api/subscription`, subscription);
    }

    updateSubscription(id: number, subscription: Partial<Subscription>): Observable<MessageResponse> {
        return this.http.put<MessageResponse>(`${environment.apiUrl}/api/subscription/${id}`, subscription);
    }

    deleteSubscription(id: number): Observable<MessageResponse> {
        return this.http.delete<MessageResponse>(`${environment.apiUrl}/api/subscription/${id}`);
    }
}
